import {
  body,
  icon,
} from './style'
import { InquiryButtonTypes } from "types"
import { Color } from 'utils/variables';
import { Icon } from 'icons/Icon'
import { H4 } from 'components/Typography/H4'

export const InquiryButton = ({onClick}: InquiryButtonTypes) => {
  return (
    <div className={body} onClick={() => onClick()}>
      <Icon name="Happy" size={27} className={icon} />
      <H4 color={Color.White}>無料通話でお問合せ</H4>
    </div>
  );
}

